import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Header from "./Header";
import Footer from "./Footer";
import "./Styles.css";

export default function AboutUsPage() {
  const buildItems = [
    "SaaS Platforms & Digital Products",
    "AI-Powered Solutions",
    "Automation & Intelligent Systems",
    "Web & Mobile Applications",
    "Enterprise Technology Products",
    "Cloud-Native Platforms",
    "Productivity & Business Solutions",
  ];

  const whyItems = [
    "Product-first mindset",
    "Innovation-driven culture",
    "Focus on scalable and sustainable solutions",
    "Strong emphasis on research and technology",
    "User-centric design and development",
    "Commitment to quality, performance, and continuous evolution",
  ];

  return (
    <>
      <Header />

      <div className="about-page">
        {/* HERO */}
        <section className="about-hero-section">
          <div className="about-glow"></div>

          <div className="container position-relative">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <p className="about-subtitle">ABOUT NEOMONKS</p>

                <h1 className="about-main-title">
                  About Us — <br />
                  <span>Neomonks Tech Pvt Ltd</span>
                </h1>

                <p className="about-text mt-4">
                  Neomonks Tech Pvt Ltd is a product-focused technology
                  company dedicated to building innovative digital solutions that solve
                  real-world problems at scale. We are creators, builders, and innovators focused
                  on developing impactful products and technology ecosystems for the future.
                </p>
              </div>

              <div className="col-lg-6">
                <div className="about-hero-card">
                  <div className="row g-4">
                    <div className="col-6">
                      <div className="mini-card">
                        <h3>AI</h3>
                        <p>Intelligent next-generation systems</p>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="mini-card mt-lg-5">
                        <h3>Cloud</h3>
                        <p>Scalable infrastructure & platforms</p>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="mini-card">
                        <h3>Scale</h3>
                        <p>Products built for long-term growth</p>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="mini-card mt-lg-5">
                        <h3>Future</h3>
                        <p>Digital experiences for tomorrow</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* OVERVIEW */}
        <section className="about-section">
          <div className="container">
            <div className="row g-5 align-items-start">
              <div className="col-lg-5">
                <p className="about-subtitle">COMPANY OVERVIEW</p>

                <h2 className="section-title">
                  Technology with purpose,
                  <span> products with impact.</span>
                </h2>
              </div>

              <div className="col-lg-7">
                <p className="about-text">
                  Driven by innovation and long-term vision, we design and
                  build scalable platforms, intelligent applications, and next-generation digital
                  products that empower businesses, communities, and users worldwide. Our
                  approach combines deep technology expertise with product thinking, allowing us
                  to create solutions that are sustainable, user-centric, and built for growth.
                </p>

                <p className="about-text mt-4">
                  At Neomonks Tech Pvt Ltd, we believe great products are born
                  from understanding real challenges. That’s why we focus on developing
                  meaningful technology solutions powered by AI, automation, cloud
                  infrastructure, and modern engineering practices.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WE BUILD */}
        <section className="about-section section-dark">
          <div className="container">
            <div className="text-center mb-5">
              <p className="about-subtitle">WHAT WE BUILD</p>

              <h2 className="section-title center-title">
                Modern digital products for a
                <span> rapidly evolving world</span>
              </h2>
            </div>

            <div className="row g-4">
              {buildItems.map((item, index) => (
                <div className="col-md-6 col-xl-4" key={index}>
                  <div className="about-feature-card">
                    <div className="feature-icon">✦</div>
                    <h3>{item}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* MISSION & VISION */}
        <section className="about-section">
          <div className="container">
            <div className="row g-4">
              <div className="col-lg-6">
                <div className="mission-card">
                  <p className="about-subtitle">OUR MISSION</p>

                  <h2>
                    To build innovative and scalable technology products that
                    simplify complexity, create value, and shape the future of digital experiences.
                  </h2>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="vision-card">
                  <p className="about-subtitle">OUR VISION</p>

                  <h2>
                    To become a globally recognized product and technology
                    company known for building transformative solutions that impact millions of
                    users and businesses.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* PHILOSOPHY */}
        <section className="about-section section-dark">
          <div className="container text-center philosophy-box">
            <p className="about-subtitle">OUR PHILOSOPHY</p>

            <h2 className="section-title center-title">
              Product-driven.
              <span> Innovation-led. Future-ready.</span>
            </h2>

            <p className="about-text philosophy-text">
              We believe technology should be product-driven,
              innovation-led, and future-ready. Instead of simply delivering projects, we
              focus on creating products and solutions that have long-term impact,
              adaptability, and scalability.
            </p>
          </div>
        </section>

        {/* WHY NEOMONKS */}
        <section className="about-section">
          <div className="container">
            <div className="text-center mb-5">
              <p className="about-subtitle">WHY NEOMONKS TECH PVT LTD</p>

              <h2 className="section-title center-title">
                Built with innovation,
                <span> driven by long-term vision</span>
              </h2>
            </div>

            <div className="row g-4">
              {whyItems.map((item, index) => (
                <div className="col-md-6 col-xl-4" key={index}>
                  <div className="about-feature-card">
                    <div className="feature-icon">✓</div>
                    <h3>{item}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FINAL SECTION */}
        <section className="about-final-section">
          <div className="container">
            <div className="about-final-box">
              <h2>
                At Neomonks Tech Pvt Ltd, we are building more than software
                — we are building products, platforms, and digital experiences that define the
                future.
              </h2>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
